module.exports = __webpack_public_path__ + "static/media/ybfStable.35526961.png";